import { PropsWithChildren, useState } from 'react';
import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

import { ChevronRightIcon } from '@treams/treams-icons';
import { Card, Expand, Paragraph, tokens } from '@treams/treams-ui';

const Header = styled(Flex)<{ clickable: boolean }>`
	cursor: ${(props) => (props.clickable ? 'pointer' : 'default')};
	user-select: none;
`;

const Chevron = styled(Box)<{ open: boolean }>`
	width: 24px;
	flex-shrink: 0;
	transition: 0.2s ease transform;
	transform: ${(props) => (props.open ? 'rotate(90deg)' : 'none')};

	svg {
		display: block;

		path {
			fill: ${tokens.text.secondary};
		}
	}
`;

const List = styled(Box)`
	max-height: 240px;
	overflow-y: auto;
`;

interface IProps {
	title: string;
	expandable: boolean;
}

export function ConversationRevealSummaryRow({
	title,
	expandable,
	children,
}: PropsWithChildren<IProps>) {
	const [open, setOpen] = useState(false);

	const handleToggle = () => {
		if (!expandable) {
			return;
		}
		setOpen((current) => !current);
	};

	const handleKeyDown = (event: React.KeyboardEvent) => {
		if (event.key === 'Enter' || event.key === ' ') {
			event.preventDefault();
			handleToggle();
		}
	};

	return (
		<Card mb={2} p={0}>
			<Header
				clickable={expandable}
				alignItems="center"
				justifyContent="space-between"
				px={3}
				py={2}
				onClick={handleToggle}
				onKeyDown={handleKeyDown}
				tabIndex={expandable ? 0 : undefined}
				role={expandable ? 'button' : undefined}
				aria-expanded={expandable ? open : undefined}
			>
				<Paragraph>{title}</Paragraph>
				{expandable && (
					<Chevron open={open}>
						<ChevronRightIcon />
					</Chevron>
				)}
			</Header>
			<Expand expanded={open}>
				<List px={3} pb={2}>
					{children}
				</List>
			</Expand>
		</Card>
	);
}
